'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _iBem = require('../i-bem/i-bem.react');

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _bKeycodes = (require('./../keycodes/keycodes.react.js').default || require('./../keycodes/keycodes.react.js')).applyDecls();

var _bKeycodes2 = _interopRequireDefault(_bKeycodes);

var _bControl = (require('./../control/control.react.js'), (require('./../../desktop.blocks/control/control.react.js').default || require('./../../desktop.blocks/control/control.react.js')).applyDecls());

var _bControl2 = _interopRequireDefault(_bControl);

var _eBox = (require('./__box/tumbler__box.react.js').default || require('./__box/tumbler__box.react.js')).applyDecls();

var _eBox2 = _interopRequireDefault(_eBox);

var _eInput = (require('./__input/tumbler__input.react.js').default || require('./__input/tumbler__input.react.js')).applyDecls();

var _eInput2 = _interopRequireDefault(_eInput);

var _eOption = (require('./__option/tumbler__option.react.js').default || require('./__option/tumbler__option.react.js')).applyDecls();

var _eOption2 = _interopRequireDefault(_eOption);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var checkKeys = [_bKeycodes2.default.LEFT, _bKeycodes2.default.RIGHT, _bKeycodes2.default.UP, _bKeycodes2.default.DOWN];

exports.default = (0, _iBem.decl)(_bControl2.default, {
    block: 'tumbler',
    tag: 'span',
    willInit: function willInit() {
        this.__base.apply(this, arguments);

        this.onChange = this.onChange.bind(this);
        this.onMouseMove = this.onMouseMove.bind(this);
        this.onClick = this.onClick.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);

        this._getLabel = this._getLabel.bind(this);
        this._defineLabelAction = this._defineLabelAction.bind(this);
    },
    attrs: function attrs(_ref) {
        var disabled = _ref.disabled,
            _attrs = _ref.attrs,
            title = _ref.title;

        return _extends({}, this.__base.apply(this, arguments), _attrs, {
            title: title,
            onMouseMove: disabled ? '' : this.onMouseMove
        });
    },
    _getControlAttrs: function _getControlAttrs() {
        return {};
    },
    mods: function mods(_ref2) {
        var view = _ref2.view,
            theme = _ref2.theme,
            size = _ref2.size,
            checked = _ref2.checked;

        return _extends({}, this.__base.apply(this, arguments), {
            view: view,
            theme: theme,
            size: size,
            checked: this.__self.bool2string(checked)
        });
    },
    getChildContext: function getChildContext() {
        return { getLabel: this._getLabel, defineLabelAction: this._defineLabelAction };
    },
    content: function content(_ref3) {
        var _this = this;

        var _ref3$id = _ref3.id,
            id = _ref3$id === undefined ? this.generateId() : _ref3$id,
            view = _ref3.view,
            name = _ref3.name,
            checked = _ref3.checked,
            disabled = _ref3.disabled,
            tabIndex = _ref3.tabIndex,
            controlAttrs = _ref3.controlAttrs,
            onVal = _ref3.onVal,
            offVal = _ref3.offVal,
            children = _ref3.children;

        var onChange = disabled ? undefined : this.onChange;

        var _setLabels = this._setLabels(children),
            leftLabel = _setLabels.leftLabel,
            rightLabel = _setLabels.rightLabel;

        return [leftLabel && _react2.default.createElement(_eOption2.default, {
            key: 'leftLabel',
            side: 'left',
            checked: checked,
            onChange: onChange,
            id: 'left' + id,
            text: leftLabel.props.text || leftLabel.props.children
        }), _react2.default.createElement(_eBox2.default, _extends({ key: 'box' }, {
            view: view,
            id: id,
            onChange: onChange,
            ref: function ref(box) {
                return _this._box = _reactDom2.default.findDOMNode(box);
            },
            checked: checked,
            disabled: disabled,
            tabIndex: tabIndex,
            buttonRef: function buttonRef(button) {
                return _this._button = _reactDom2.default.findDOMNode(button);
            }
        })), _react2.default.createElement(_eInput2.default, _extends({ key: 'input' }, {
            id: id,
            name: name,
            onVal: onVal,
            offVal: offVal,
            checked: checked,
            disabled: disabled,
            onChange: onChange,
            attrs: controlAttrs
        })), rightLabel && _react2.default.createElement(_eOption2.default, {
            key: 'rightLabel',
            side: 'right',
            checked: checked,
            onChange: onChange,
            id: 'right' + id,
            text: rightLabel.props.text || rightLabel.props.children
        })];
    },
    onChange: function onChange(e) {
        this.props.onChange && this.props.onChange(e);
    },
    onClick: function onClick(e) {
        if (e.target === this.DOMNode) {
            this.inputElement.click();
        }
    },
    onKeyUp: function onKeyUp(e) {
        if (e.which === _bKeycodes2.default.SPACE) {
            this.setState({ pressed: false });
        }
        this.props.onKeyUp && this.props.onKeyUp(e);
    },
    onKeyDown: function onKeyDown(e) {
        if (e.which === _bKeycodes2.default.SPACE) {
            this.setState({ pressed: true });
        }

        // Предотвращаем прокрутку страницы.
        checkKeys.indexOf(e.which) !== -1 && e.preventDefault();

        if (this.props.checked) {
            _bKeycodes2.default.is(e.which, 'LEFT', 'DOWN') && this.onChange(e);
        } else {
            _bKeycodes2.default.is(e.which, 'RIGHT', 'UP') && this.onChange(e);
        }

        this.props.onKeyDown && this.props.onKeyDown(e);
    },
    onMouseMove: function onMouseMove(e) {
        if (this.props.view === 'classic') {
            if (e.target !== this._button && this._box.contains(e.target)) {
                this.setState({ hovered: true });
            } else {
                this.setState({ hovered: false });
            }
        } else {
            this.setState({ hovered: true });
        }
    },
    _setLabels: function _setLabels(labels) {
        if (_react.Children.count(labels) === 2) {
            return { leftLabel: labels[0], rightLabel: labels[1] };
        } else if (_react.Children.count(labels)) {
            var side = labels.props.side;

            return side === 'left' || !side ? { leftLabel: labels } : { rightLabel: labels };
        }
        return {};
    },
    _getLabel: function _getLabel(id) {
        var _props = this.props,
            checked = _props.checked,
            labels = _props.children;


        if (_react.Children.count(labels) === 2) {
            return checked ? 'left' + id : 'right' + id;
        } else if (_react.Children.count(labels)) {
            var side = labels.props.side;

            return side === 'left' || !side ? 'left' + id : 'right' + id;
        }
    },
    _defineLabelAction: function _defineLabelAction(side, action) {
        var _props2 = this.props,
            checked = _props2.checked,
            labels = _props2.children;


        if (_react.Children.count(labels) === 2) {
            action = checked && side !== 'left' || !checked && side !== 'right' ? undefined : action;
        }
        return action;
    }
}, {
    Option: _eOption2.default,
    On: _eOption2.default,
    Off: _eOption2.default,
    propTypes: {
        view: _propTypes2.default.string,
        tone: _propTypes2.default.oneOf(['default', 'red', 'grey', 'dark']),
        size: _propTypes2.default.oneOf(['xs', 's', 'm', 'n']),
        theme: _propTypes2.default.oneOf(['normal', 'tiny']),
        children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.array])
    },
    defaultProps: {
        view: 'classic'
    },
    childContextTypes: {
        getLabel: _propTypes2.default.func,
        defineLabelAction: _propTypes2.default.func
    }
});